<div class="legends my-32">
    <div class="legend" *ngFor="let legend of legends">
        <div [ngClass]="'color color-' + legend.colorType"></div>
        <div class="label">{{ legend.label }}</div>
    </div>
</div>